import {
  BARCODE_SCAN,
  BARCODE_REG,
  ACTION_BARCODE_START,
  ACTION_BARCODE_END,
  CHANGE_BARCODE_STATE_LOCAL,
} from './barCodeScan.actiontype';
import axiosService from '../../../inits/axios';
import { setToasterMessage } from '../commonAction/common.action';
import {
  AlertType,
  STOCK_IN_OPTIONS,
} from '../../../utils/constants/values.constants';
import { convertObjectToParams } from '../../../utils/utils';
import { config } from '../../../utils/constants/api.constants';

export const barCodeScan =
  (body, appointmentId, params = {}) =>
  async (dispatch) => {
    dispatch({ type: ACTION_BARCODE_START });
    const url =
      config.api.inventory.host +
      config.api.inventory.api_version +
      config.api.inventory.inventory +
      '/apt-' +
      appointmentId +
      convertObjectToParams(params);

    try {
      const data = await axiosService.post(url, body);
      dispatch(
        setToasterMessage({
          toasterMessage: 'BarCode saved successfully!',
          showToaster: true,
          toasterType: AlertType.SUCCESS,
          statusCode: 200,
        })
      );
      dispatch({
        type: BARCODE_SCAN,
        payload: data.data ? data.data : 'success',
      });
    } catch (e) {
      if (e.response.status === 500 || e.response.data) {
        dispatch(
          setToasterMessage({
            toasterMessage: e.response.data.message
              ? e.response.data.message
              : e.response.data.error,
            showToaster: true,
            toasterType: AlertType.ERROR,
            statusCode: e.response.status,
          })
        );
      }
      dispatch({ type: ACTION_BARCODE_END });
    }
  };

export const stockInByBarCode =
  (body, stockInByLabel, stockInParam, params = {}) =>
  async (dispatch) => {
    dispatch({ type: ACTION_BARCODE_START });

    let url;

    if (stockInByLabel === STOCK_IN_OPTIONS['registrationNumber'].value) {
      url =
        config.api.inventory.host +
        config.api.inventory.api_version +
        config.api.inventory.inventory +
        '/reg-' +
        stockInParam +
        convertObjectToParams(params);
    } else {
      url =
        config.api.inventory.host +
        config.api.inventory.api_version +
        config.api.inventory.inventory +
        '/chassis-testChassisNumber' +
        convertObjectToParams(params);
    }

    try {
      const data = await axiosService.post(url, body);
      dispatch(
        setToasterMessage({
          toasterMessage: 'Stock-in done successfully!',
          showToaster: true,
          toasterType: AlertType.SUCCESS,
          statusCode: 200,
        })
      );
      dispatch({
        type: BARCODE_REG,
        payload: data.data ? data.data : 'success',
      });
    } catch (e) {
      if (e.response.status === 500 || e.response.data) {
        dispatch(
          setToasterMessage({
            toasterMessage: e.response.data.message
              ? e.response.data.message
              : e.response.data.error,
            showToaster: true,
            toasterType: AlertType.ERROR,
            statusCode: e.response.status,
          })
        );
      }
      dispatch({ type: ACTION_BARCODE_END });
    }
  };

export const changeBarCodeStateLocal = () => async (dispatch) => {
  dispatch({ type: CHANGE_BARCODE_STATE_LOCAL });
};

const FILE_VERSION = process.env.REACT_APP_FILE_VERSION;
